import { useQuery } from "@tanstack/react-query";

import { supabaseClient } from "@/lib/supabase";

export function useOrganisationCliniciansQuery(organisationId: string) {
	return useQuery({
		queryKey: ["clinicians", { organisationId }],
		queryFn: async () => {
			const { data, error } = await supabaseClient
				.from("profiles")
				.select("user_id, name, email")
				.eq("organisation_id", organisationId)
				.eq("role", "CLINICIAN");

			if (error) throw error;
			return data;
		},
	});
}
